/**
 * @generated SignedSource<<b49be111c4a9f289bd0bd14b50caae97>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Role = "ADMIN" | "APPROVER" | "EDITOR" | "%future added value";
export type AdminCreateUserRequest = {
  accountId: string;
  accountRoles?: ReadonlyArray<Role> | null;
  brandAccess?: ReadonlyArray<AdminBrandAccessInput> | null;
  email: string;
  featureFlagIds?: ReadonlyArray<string> | null;
  firstName?: string | null;
  fullName?: string | null;
  lastName?: string | null;
  superuser?: boolean | null;
};
export type AdminBrandAccessInput = {
  brandId: string;
  roles: ReadonlyArray<Role>;
};
export type UserFormDialogCreateMutation$variables = {
  input: AdminCreateUserRequest;
};
export type UserFormDialogCreateMutation$data = {
  readonly createUser: {
    readonly id: string;
  };
};
export type UserFormDialogCreateMutation = {
  response: UserFormDialogCreateMutation$data;
  variables: UserFormDialogCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminUser",
    "kind": "LinkedField",
    "name": "createUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserFormDialogCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserFormDialogCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "64dc983dd1ef1fde5a7b9c68913800e5",
    "id": null,
    "metadata": {},
    "name": "UserFormDialogCreateMutation",
    "operationKind": "mutation",
    "text": "mutation UserFormDialogCreateMutation(\n  $input: AdminCreateUserRequest!\n) {\n  createUser(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9265ea677ac24806deb593e448967b01";

export default node;
